import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { createIdentity } from '../helpers/create-identity';
import {
    logErrorFromClientSdk,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface CreateIdentityOrLoginFnPayload {
    email: string;
    password?: string;
    language: string;
}

export type CreateIdentityOrLoginFn = (
    payload: CreateIdentityOrLoginFnPayload,
) => Promise<'create' | 'login'>;

export function initCreateIdentityOrLoginFn({
    dependencies,
}: DomainInitPayload): CreateIdentityOrLoginFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async ({
        email,
        password,
        language,
    }: CreateIdentityOrLoginFnPayload) => {
        let result;
        try {
            const payload = {
                emailAddress: email,
                password,
                language,
            };
            await clientSdk.user.anonymousLogin(true);
            await createIdentity(payload, dependencies);
            appEventSdk.trackEvent({
                event: 'customer-info',
                data: {
                    customerType: 'NEW_SXIR_ACCOUNT',
                },
            });
            result = 'create';
        } catch (error: any) {
            if (password && error.message === 'IDENTITY_ALREADY_EXISTS_ERROR') {
                try {
                    await clientSdk.user.login({ handle: email, password });
                    result = 'login';
                } catch (error: any) {
                    if (
                        error.code ===
                        'userServices.identity.invalidCredentials'
                    ) {
                        trackBusinessError(appEventSdk, error);
                        throw new Error('INVALID_CREDENTIALS_ERROR');
                    } else {
                        logErrorFromClientSdk(error, dependencies);
                        throw new Error('SYSTEM');
                    }
                }
            } else {
                throw error;
            }
        }
        return result === 'create' ? 'create' : 'login';
    };
}
